import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { Heading } from './Heading'

const Field = ({ fieldName, value }) => {
    return (
        <Box pt={1} pb={1}>
            <Typography color="textSecondary" style={{ fontSize: '0.9rem' }}>
                {fieldName}
            </Typography>
            <Typography style={{ fontWeight: '600' }}>{value}</Typography>
        </Box>
    )
}

export const PersonalDetails = ({ name, gender, dob }) => {
    return (
        <Box p={2} pt={2} pb={2}>
            <Heading heading={'Personal Details'} />
            <Box
                pb={2}
                sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    borderBottom: 'solid 1px #E5E7EB',
                }}
            >
                <Field fieldName={'Name'} value={name} />
                {/* <Field fieldName={"First Name"} value={name.split(" ")[0]} />
        <Field fieldName={"Last Name"} value={name.split(" ")[1]} /> */}
                <Field fieldName={'Gender'} value={gender || 'Male'} />
                <Field
                    fieldName={'Date of Birth'}
                    value={dob || 'Not Available'} //(26 years old) implement automatic age calc with text secondary color
                />
            </Box>
        </Box>
    )
}
